import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Orders from '../views/Orders.vue';
import Pricing from '../views/Pricing.vue';
import ApiKeys from '../views/ApiKeys.vue';
import ApiDocs from '../views/ApiDocs.vue';
import McpDocs from '../views/McpDocs.vue';
import { refreshUserFromServer } from '../utils/auth.js';

/** 将 /login、/register 转到首页并带上 auth 查询，保留 redirect */
function authEntryRedirect(to, auth) {
  const r = to.query.redirect;
  let path = '/single';
  if (typeof r === 'string') {
    const base = r.split('?')[0];
    if (base === '/batch' || base === '/single') path = base;
  }
  const q = { auth };
  if (typeof r === 'string') q.redirect = r;
  return { path, query: q };
}

const routes = [
  {
    path: '/',
    redirect: '/single'
  },
  {
    path: '/single',
    name: 'SingleQuery',
    component: Home,
    props: () => ({ defaultTab: 'single' })
  },
  {
    path: '/batch',
    name: 'BatchProcess',
    component: Home,
    props: () => ({ defaultTab: 'batch' })
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing
  },
  {
    path: '/settings/api-keys',
    name: 'ApiKeys',
    component: ApiKeys
  },
  {
    path: '/api-keys',
    redirect: '/settings/api-keys'
  },
  {
    path: '/docs/api',
    name: 'ApiDocs',
    component: ApiDocs
  },
  {
    path: '/docs/mcp',
    name: 'McpDocs',
    component: McpDocs
  },
  {
    path: '/login',
    redirect: (to) => authEntryRedirect(to, 'login')
  },
  {
    path: '/register',
    redirect: (to) => authEntryRedirect(to, 'register')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  await refreshUserFromServer();
  next();
});

export default router;
